import * as R from 'ramda';

import sportsApi from '../../utils/sportsApi';
import getFilters from '../../selectors/getSelectedFilters';
import getUseRightsholderAttribution from '../../utils/getUseRightsholderAttribution';
import { normalize, schema } from 'normalizr';

const socialPostList = new schema.Entity('socialPostList', undefined, {
    // idAttribute *functions* must return the ids **value** (not key)
    idAttribute: value => value.id,
});

const getTopSocialPosts = store => async state => {
    const userClientId = state.user.selectedUserClientId;
    const filters = state.clients[userClientId].filters;
    const clientId = state.user.selectedClientId;
    const client = state.user.clientsById[clientId];
    const useRightsholderAttribution = getUseRightsholderAttribution(
        client,
        clientId,
    );

    const loadingState = R.assocPath(
        ['clients', userClientId, 'home', 'socialStream', 'isLoading'],
        true,
        state,
    );

    store.setState(loadingState);

    const globFilters = getFilters(filters);

    const platformsQuery = {
        action: 'fetchQuery',
        domainObject: {
            ...globFilters,
            pageSize: 20,
            avgMvpScoreGreaterThan: 0.5,
            orderBy: ['sponsorMediaValue-desc'],
            includeTextTypeExposures: true,
            includeTextMediaTypes: true,
            ...(useRightsholderAttribution
                ? { useRightsholderAttribution: true }
                : {}),
        },
    };

    const { posts } = await sportsApi
        .url('/social-posts')
        .json(platformsQuery)
        .post()
        .json();

    const normalizedData = normalize(posts, [socialPostList]);

    store.setState(
        R.assocPath(
            ['clients', userClientId, 'home', 'socialStream'],
            {
                isLoading: false,
                posts: normalizedData.entities.socialPostList || {},
                postsOrder: normalizedData.result || [],
            },
            store.getState(),
        ),
        true,
    );
};

export default getTopSocialPosts;
